<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setAssetLabelFilter(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="asset_label_filter"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setAssetLabelFilter(false)"
    >
      <el-input type="text" v-model="name" placeholder="Name" clearable />
      <el-checkbox class="ml10 mt10" v-model="unassigned" label="Unassigned Asset Labels"></el-checkbox>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      name: '',
      unassigned: false
    }
  },
  computed: {
    ...mapState('youtubeUsers', ['asset_label_filter'])
  },
  methods: {
    ...mapMutations('youtubeUsers', ['setAssetLabelFilter', 'setFilter', "setPage"]),
    ...mapActions('youtubeUsers', ['listAssetLabels']),

    filter() {
      if (this.unassigned == true) {
        this.setFilter({
          name: this.name,
          unassigned: this.unassigned,
        })
      } else {

        this.setFilter({
          name: this.name,
        })
      }
      this.setPage(1)
      this.listAssetLabels()
      this.setAssetLabelFilter(false)
    },

    clear() {
      this.setFilter({})
      this.setPage(1)
      this.listAssetLabels()
      this.name = ''
      this.unassigned = false
      this.setAssetLabelFilter(false)
    }
  }
}
</script>
